// extracted by mini-css-extract-plugin
export var accent = "QuoteBreaker-module--accent--a8ab1";
export var altaccent = "QuoteBreaker-module--altaccent--83462";
export var authorPhoto = "QuoteBreaker-module--authorPhoto--56848";
export var box = "QuoteBreaker-module--box--cb98b";
export var breaker = "QuoteBreaker-module--breaker--fb0e9";
export var content = "QuoteBreaker-module--content--6f328";
export var footer = "QuoteBreaker-module--footer--bf10e";
export var icon = "QuoteBreaker-module--icon--ac18d";